module.exports = __webpack_public_path__ + "img/individual-meter-heat-meter-counter-sm.aab5f2bd.svg";